<template xmlns:background-color="http://www.w3.org/1999/xhtml">
  <a-row :gutter="10">
    <a-col :md="10" :sm="24">
      <a-card :bordered="false">

        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{language['depart.management.selectedDepart']}}：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{language['depart.management.cancelSelected']}}</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" :placeholder="language['common.pleaseInput']+language['depart.management.departName']"/>
          <!-- 树-->
          <a-col :md="10" :sm="24" style="max-height: 100vh;overflow-y:scroll;overflow-x: hidden;width: 100%">
            <template>
              <a-dropdown  style="height: 100px">
                <span style="user-select: none">
                  <a-tree
                    @select="onSelect"
                    :selectedKeys="selectedKeys"
                    :checkedKeys="checkedKeys"
                    :treeData="departTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand"/>
                </span>

              </a-dropdown>
            </template>
          </a-col>
        </div>
      </a-card>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <!--<a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>-->
            <a-menu-item key="3" @click="checkALL">{{language['system.allcheck']}}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{language['system.cancelcheckall']}}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{language['system.expenseall']}}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{language['system.collegeall']}}</a-menu-item>
          </a-menu>
          <a-button>
            {{language['system.treeoperate']}} <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    </a-col>
    <a-col :md="14" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="language['system.departSigne.signeSet']" key="1" >
          <signed-model ref="signedModel" :depart-id="this.selectedKeys?this.selectedKeys[0]:''"></signed-model>
        </a-tab-pane>
<!--        <a-tab-pane :tab="language['depart.management.deportProemission']" key="2" forceRender>
        </a-tab-pane>-->
      </a-tabs>

    </a-col>
  </a-row>
</template>
<script>

  import {queryDepartTreeList, searchByKeywords, deleteByDepartId} from '@/api/api'
  import {httpAction, deleteAction, getAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SignedModel from './modules/SignedModel'
  // 表头

  export default {
    name: 'DepartList',
    mixins: [JeecgListMixin],
    components: {
      SignedModel
    },
    data() {
      return {
        appCode:this.$store.getters.applicationCode,


        artificialPersonList:[{
          id:'',
          applicationName:''
        }],
        siteCodeList:[{
          id:'',
          xxx:''
        }],
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: true,
        currFlowId: '',
        currFlowName: '',
        disable: true,
        treeData: [],
        importPlatformbtn:true,
        departTree: [],
        // standardDepartShow:true,
        hiding: true,
        model: {},
        // dropTrigger: '',
        depart: {},
        checkedKeys: [],
        selectedKeys: [],
        currSelected: {},
        allTreeKeys:[],
        checkStrictly: true,
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        graphDatasource: {
          nodes: [],
          edges: []
        },
        validatorRules: {
          departName: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.departName']}],
          orgCode: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.orgCode']}],
          orgCategory:[{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.orgCategory']}],
          mobile:[{validator: this.validateMobile}],
          levelNo:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['depart.management.levelNo'] }],
        },
        url: {
          delete: '/sys/sysDepart/delete',
          edit: '/sys/sysDepart/edit',
          deleteBatch: '/sys/sysDepart/deleteBatch',
          exportXlsUrl: "sys/sysDepart/exportXls",
          importExcelUrl: "sys/sysDepart/importExcel",
        },
        orgCategoryDisabled:false,

        departMangerURL:'/sys/user/queryList?applicationCode='+this.$store.getters.applicationCode+'&applicationBy=user',
      }
    },
    created(){
      this.onClearSelected();
      this.currFlowId = this.$route.params.id
      this.currFlowName = this.$route.params.name
      // this.loadTree()
      this.getLegalPersons();
      this.getDepartSites();
    },
    computed: {

      language() {
        return this.$store.getters.language
      },


    },
    methods: {
      uploadDepartXls(){
        this.$refs.DepartUploadOrDownloadModal.edit()
      },


      /*selectStandardDepart(){
        this.$refs.standardDepartModal.loadTree()
      },*/
      loadData() {
        this.refresh();
      },
      loadTree() {
        var that = this
        that.treeData = []
        that.departTree = []
        getAction("/sys/sysDepart/queryChargeDataTreeList",{"applicationCode":this.$store.getters.applicationCode}).then((res) => {
        // queryDepartTreeList({"applicationCode":this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            if(res.result.length==0){
              this.importPlatformbtn = false;
            }else{
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.treeData.push(temp)
                that.departTree.push(temp)
                /*展开所有节点*/
                // that.setThisExpandedKeys(temp)
                that.getAllKeys(temp);
                // console.log(temp.id)
              }
            }
            /*if(that.departTree==[]){
              that.standardDepartShow=true;
            }else{
              that.standardDepartShow=false;
            }*/
            this.loading = false
          }
        })
      },
      getLegalPersons(){
        getAction("/sys/sysDepart/getLegalPersonList").then((res) => {//{id: this.model.artificialPerson}
          if (res.success) {
            this.artificialPersonList = res.result;
          }
        })
      },
      getDepartSites(){
        getAction("/sys/sysDepart/getFactoryList").then((res) => {//, {id: this.model.siteCode}
          if (res.success) {
            this.siteCodeList = res.result;
          }
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
        }
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },

      onSearch(value) {
        let that = this
        if (value) {
          searchByKeywords({keyWord: value}).then((res) => {
            if (res.success) {
              that.departTree = []
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
              }
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }

      },
      onSelect(selectedKeys, e) {
        // debugger
        console.log('selected', selectedKeys, e)
        this.hiding = false
        let record = e.node.dataRef
        // this.departMangerURL = '/sys/user/getDepartUserForConditions?departId='+record.id
        // this.departMangerURL = '/sys/user/getDepartUser?applicationCode='+this.$store.getters.applicationCode
        console.log('onSelect-record', record)
        this.currSelected = Object.assign({}, record)
        this.selectedKeys = [record.key]
        // this.$refs.departAuth.show(record.id);
        /*this.$refs.DeptUserInfo.onClearSelected();
        this.$refs.DeptUserInfo.open(record);*/

      },
      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.selectedKeys = []
        // this.$refs.departAuth.departId = ''
      },
      submitCurrForm() {
        this.currSelected.departChief = this.model.departChief;
        this.$refs.form.validate(valid => {
          if (valid) {
            if (!this.currSelected.id) {
              this.$message.warning(this.language["common.pleaseChoose"]+this.language['deport'])
              return
            }
            httpAction(this.url.edit, this.currSelected, 'put').then((res) => {
              if (res.success) {
                this.$message.success(this.language['system.savedSuccess'])
                this.loadTree()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },
      emptyCurrForm() {
        this.$refs.form.resetFields();
        this.model={}
      },
      openSelect() {
        this.$refs.sysDirectiveModal.show()
      },
     //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      checkALL () {
        this.checkStriccheckStrictlytly = false
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if(v==1){
          this.checkStrictly = false
        }else if(v==2){
          this.checkStrictly = true
        }
      },
      getAllKeys(node) {
        // console.log('node',node);
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      }
      //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------

    },

  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin: 15px;
  }

  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>